import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCode } from "react-icons/fa";
import { resetApp } from "../../store/actions";
import { useDispatch } from "react-redux";
import ActionButton from "./ActionButton";

const DirectRenderButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function resetAndNavigate() {
    dispatch(resetApp());
    navigate("/direct-render");
  }

  return (
    <ActionButton
      icon={FaCode}
      tooltip="Direct Render"
      onClick={resetAndNavigate}
    />
  );
};

export default DirectRenderButton;
